import React from "react";
import useStatusResolution from "./useStatusResolution.logic";
import { Select, Flex, Checkbox } from "@mantine/core";
import ChangeStatusModal from "./ChangeStatusModal";
import dayjs from "dayjs";
import { dateFormat } from "../../../../../utils/dateFormat";

const StatusResolution = () => {
  const {
    options,
    resolutionStatus,
    locked,
    role,
    dueDate,
    dueDateCheck,
    canClickCheckBox,
    isPastDate,
    id,
    handleDueDateCheck,
  } = useStatusResolution();
  const [selectedStatus, setSelectedStatus] = React.useState(resolutionStatus);

  return (
    <Flex direction="column" gap={5}>
      <Flex align="center" justify="space-between" gap={5}>
        <Select
          miw={200}
          disabled={locked}
          value={selectedStatus}
          onChange={(value) => setSelectedStatus(value)}
          placeholder="Select status"
          data={options}
          styles={{
            groupLabel: {
              fontWeight: 700,
              color: "var(--mantine-color-primary-7)",
              textTransform: "uppercase",
              letterSpacing: 1,
            },
            option: {
              height: "30px",
            },
          }}
        />

        <ChangeStatusModal
          disabled={!selectedStatus || resolutionStatus === selectedStatus}
          locked={locked}
          resolutionValue={selectedStatus}
          role={role}
          id={id}
        />
      </Flex>

      {dueDate ? (
        <Checkbox
          disabled={
            locked || !!dueDateCheck || !canClickCheckBox || !isPastDate
          }
          defaultChecked={!!dueDateCheck}
          onChange={handleDueDateCheck}
          label={dayjs(dueDate).format(dateFormat)}
        />
      ) : null}
    </Flex>
  );
};

export default StatusResolution;
